import { mapParamToItem } from '../manifest-mappers/conversion-utils';
import { StyleType } from '../types/metadata/variants';
export const resolveDefaultValue = _ref => {
  let {
    metadata,
    params,
    isMobile = false,
    t
  } = _ref;
  const resolvedMetadata = resolveMetadata(metadata, t);
  const resolvedParams = Object.fromEntries(Object.entries(params).map(_ref2 => {
    let [key, value] = _ref2;
    return [key, {
      metadata: value.metadata ? resolveMetadata(value.metadata, t) : undefined
    }];
  }));
  const item = mapParamToItem({
    metadata: resolvedMetadata,
    params: resolvedParams,
    isMobile,
    validate: () => true,
    createItem: (itemType, defaultValue) => {
      if (isStyleType(itemType)) {
        return {
          cssPropertyType: itemType,
          defaultValue
        };
      } else {
        return {
          dataType: itemType,
          defaultValue
        };
      }
    }
  });
  return item == null ? void 0 : item.defaultValue;
};
const resolveMetadata = (metadata, t) => typeof metadata === 'function' ? metadata({
  t
}) : metadata;
const isStyleType = type => type in StyleType;
//# sourceMappingURL=resolve-default-values.js.map